var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSupportUser
    ? _c("div", { staticClass: "tile is-parent pl-1" }, [
        _c("section", { staticClass: "tile is-child box" }, [
          _vm._m(0),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column is-four-fifths" },
              [
                _vm._m(1),
                _vm._l(_vm.repxStages, function (stage, key) {
                  return _c("div", { key: key }, [
                    Array.isArray(_vm.repxStageSettings[key])
                      ? _c(
                          "div",
                          { staticClass: "pb-3" },
                          [
                            _c(
                              "ExpendableDiv",
                              {
                                ref: _vm.setExpendableDivRefs,
                                refInFor: true,
                                style: {
                                  border: !(
                                    _vm.repxStageSettings[key][0].length > 0
                                  )
                                    ? "1px solid #D92550"
                                    : "",
                                },
                                attrs: {
                                  title: _vm.castToTitleCase(stage),
                                  "sub-title":
                                    Array.isArray(_vm.repxStageSettings[key]) &&
                                    Array.isArray(
                                      _vm.repxStageSettings[key][0]
                                    ) &&
                                    _vm.repxStageSettings[key][0][0]
                                      ? `${
                                          _vm.repxStageSettings[key][0][0]
                                            .jobStageName
                                        } ${
                                          _vm.repxStageSettings[key][0][0]
                                            .subJobStageName &&
                                          `- ${_vm.repxStageSettings[key][0][0].subJobStageName}`
                                        }`
                                      : "",
                                  "expended-title": "RepX Stage",
                                  "expended-sub-title": "Map With",
                                },
                              },
                              [
                                _c("div", { staticClass: "columns" }, [
                                  _c("div", { staticClass: "column is-half" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "tile is-ancestor no-margin",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tile is-parent is-vertical",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "tile is-child" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "label" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.castToTitleCase(
                                                          stage
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "column is-half" },
                                    _vm._l(
                                      _vm.repxStageSettings[key],
                                      function (input, index) {
                                        return _c("div", { key: index }, [
                                          _c(
                                            "div",
                                            [
                                              _c("Multiselect", {
                                                class: {
                                                  "is-danger": !(
                                                    _vm.repxStageSettings[key][
                                                      index
                                                    ].length > 0
                                                  ),
                                                },
                                                attrs: {
                                                  options:
                                                    _vm.jobStagesAvailable,
                                                  "hide-selected": true,
                                                  multiple: true,
                                                  "close-on-select": false,
                                                  "clear-on-select": true,
                                                  "show-labels": false,
                                                  "preserve-search": true,
                                                  searchable: true,
                                                  "internal-search": true,
                                                  placeholder:
                                                    "Please select a Job Stage",
                                                  "track-by": "compositeKey",
                                                  label: "compositeName",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.limitSelection(
                                                      $event,
                                                      key
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.repxStageSettings[key][
                                                      index
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.repxStageSettings[
                                                        key
                                                      ],
                                                      index,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "repxStageSettings[key][index]",
                                                },
                                              }),
                                              !(
                                                _vm.repxStageSettings[key][
                                                  index
                                                ].length > 0
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "help is-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Field is required."
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                }),
              ],
              2
            ),
            _c("div", { staticClass: "column is-one-fifths" }, [
              _c("h3", { staticClass: "subtitle" }, [
                _vm._v("Available Stages"),
              ]),
              !_vm.isMapped
                ? _c(
                    "div",
                    {
                      staticClass:
                        "p-4 has-background-warning-light has-text-warning mb-2",
                      staticStyle: {
                        border: "1px solid #ffdd57",
                        "border-radius": "5px",
                        "font-size": "0.9em",
                      },
                    },
                    [_vm._m(2)]
                  )
                : _vm._e(),
              _c(
                "ul",
                _vm._l(_vm.jobStages, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.stage,
                      staticClass: "has-text-weight-bold is-flex",
                      class: `has-background-${_vm.$theme.name}`,
                    },
                    [
                      _c("span", { staticClass: "mt-2 job-stage" }, [
                        _vm._v(" " + _vm._s(item.description) + " "),
                      ]),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isMultipleSelectedStage(item.stage),
                            expression: "isMultipleSelectedStage(item.stage)",
                          },
                        ],
                        staticClass:
                          "icon mdi mdi-24 mdi-layers is-align-self-center",
                      }),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isSelectedStage(item.stage),
                            expression: "isSelectedStage(item.stage)",
                          },
                        ],
                        staticClass:
                          "icon mdi mdi-24 mdi-check is-align-self-center",
                      }),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
        _c(
          "div",
          {
            staticClass:
              "notification is-danger is-flex is-justify-content-center is-size-4",
            staticStyle: { width: "50%" },
          },
          [_vm._v(" You do not have permissions on this page ")]
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "subtitle mb-5" }, [_vm._v("RepX Stages Setup")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-half" }, [
        _c("span", { staticClass: "subtitle" }, [_vm._v("Repair Stages")]),
      ]),
      _c("div", { staticClass: "column is-half" }, [
        _c("span", { staticClass: "subtitle" }, [_vm._v("FlexiQuote Stages")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "is-flex is-align-items-center" }, [
      _c("span", { staticClass: "icon mr-3" }, [
        _c("i", { staticClass: "mdi mdi-alert-outline mdi-24px" }),
      ]),
      _c("div", [
        _c("p", [_vm._v("No Available Sub Stages.")]),
        _c("p", [_vm._v("Please check the Sub Stage Setup Tab.")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }